<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Printers"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
    v-if="loaded"
  >
    <ItpBox
      alignItems="center"
      class="mb-3"
    >
      <strong>
        {{ 'Printer configurations'|pgettext('Printers') }}
      </strong>
      <ItpButton
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        variant="light"
        size="sm"
        :spinning="actions.reload.isRunning"
        class="ml-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        :text="'Add printer...'|pgettext('Printers')"
        variant="light"
        size="sm"
        class="ml-3"
        @click.prevent.stop="evh_6705964765214521_clickPreventStop($event, {})"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Export'|pgettext('Printers')"
        variant="light"
        size="sm"
        :disabled="!items || !items.length"
        use-auth
        force-download
        downloadFileName="printer-configurations.yaml"
        :href="$fn.urlFor('export_object_by_type', {object_type: objectType})"
        class="ml-3"
      >
      </ItpButton>
      <ItpButton
        icon="fa-file-invoice"
        :text="'Import'|pgettext('Printers')"
        variant="light"
        size="sm"
        class="ml-3"
        @click.prevent.stop="evh_8116269939469002_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <ItpDataTable
      tableId="Settings.Printers"
      :editable="b_3343864469950044_editable"
      :value="items"
      :globs="{ open }"
      :columns="b_3343864469950044_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.printers",
    path: "printers",
    component: "Printers"
  }
)

@Component()
export default class Printers extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  open(...args: any[]) {
    const [oid] = args;
    const updateItem = this.updateItem;

    return this.$imodal
      .show({
        name: 'PrinterConfig',
        props: { oid }
      })
      .then(res => this.loadData('items'))
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  objectType!: any;
  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_object_by_type', { parameters: { object_type: this.$data.objectType } })
      .then(items => _.orderBy(items, ['created_at'], ['asc']))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3343864469950044_editable!: any;
  b_3343864469950044_columns!: any;
  dataMembers = ['objectType', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_editable', 'b_3343864469950044_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        objectType: "printer",
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_3343864469950044_editable: false,
        b_3343864469950044_columns: [{
          name: "id",
          header: this.$fn.pgettext("Printer", "ID"),
          width: "180px",
          formatter: {
            name: "template",
            value: "<div>\n\
  <a class=\"text-nowrap\"\n\
     href=\"#\"\n\
     @click=\"globs.open(row.id)\"\n\
  >\n\
    {{ value }}\n\
  </a>\n\
</div>\n\
",
          }
          ,
        }
          ,
        {
          name: "name",
          header: this.$fn.pgettext("Printer", "Name"),
          width: "180px",
        }
          ,
        {
          name: "uri",
          header: this.$fn.pgettext("Printer", "URI"),
          width: "180px",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5064_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5064, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_6705964765214521_script_5068_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6705964765214521_script_5068, alias=undefined
    this.open()
  }

  async act_6705964765214521_script_5068_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6705964765214521_script_5068, alias=undefined
    return {
      value: () => this.act_6705964765214521_script_5068_getActionArgs_value($event),
    }
  }

  async evh_6705964765214521_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_8116269939469002_showModal_5070_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_8116269939469002_showModal_5070, alias=undefined
    return {
      name: "FileSelector",
      props: {
        url: this.$fn.urlFor('import_object_by_type', { object_type: this.objectType }),
        accept: ".yaml",
      }
      ,
    }
  }

  async evh_8116269939469002_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5064: actions.CloseModalAction;
    evh_7315092382398562_close_5063: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_5066: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_5065: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_6705964765214521_script_5068: actions.ScriptAction;
    evh_6705964765214521_clickPreventStop_5067: actions.EventHandlerImpl;
    evh_6705964765214521_clickPreventStop: actions.EventHandlerGroup;
    act_8116269939469002_showModal_5070: actions.ShowModalAction;
    evh_8116269939469002_clickPreventStop_5069: actions.EventHandlerImpl;
    evh_8116269939469002_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5064 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5064_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5063 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5064,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5063],
      }
    );
    const act_8320016629450276_reloadComponentData_5066 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_5065 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_5066,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_5065],
      }
    );
    const act_6705964765214521_script_5068 = new actions.ScriptAction(
      {
        actionArgs: this.act_6705964765214521_script_5068_getActionArgs,
        events: [],
      }
    );
    const evh_6705964765214521_clickPreventStop_5067 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_script_5068,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_6705964765214521_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_clickPreventStop_5067],
      }
    );
    const act_8116269939469002_showModal_5070 = new actions.ShowModalAction(
      {
        actionArgs: this.act_8116269939469002_showModal_5070_getActionArgs,
        events: [],
      }
    );
    const evh_8116269939469002_clickPreventStop_5069 = new actions.EventHandlerImpl(
      {
        action: act_8116269939469002_showModal_5070,
        event: "click.prevent.stop",
        displayName: "showModal",
      }
    );
    const evh_8116269939469002_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8116269939469002_clickPreventStop_5069],
      }
    );
    return {
      act_7315092382398562_closeModal_5064,
      evh_7315092382398562_close_5063,
      evh_7315092382398562_close,
      act_8320016629450276_reloadComponentData_5066,
      evh_8320016629450276_clickPreventStop_5065,
      evh_8320016629450276_clickPreventStop,
      act_6705964765214521_script_5068,
      evh_6705964765214521_clickPreventStop_5067,
      evh_6705964765214521_clickPreventStop,
      act_8116269939469002_showModal_5070,
      evh_8116269939469002_clickPreventStop_5069,
      evh_8116269939469002_clickPreventStop,
      reload: act_8320016629450276_reloadComponentData_5066,
    }
  }
}

Vue.component("Printers", Printers);

</script>